var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOutlookCalendar = function SvgOutlookCalendar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32101_39062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9996 15.6285C32.0013 15.3783 31.872 15.1454 31.6588 15.0146H31.655L31.6416 15.0071L20.5533 8.44342C20.5054 8.41107 20.4557 8.3815 20.4044 8.35487C19.9763 8.13399 19.4677 8.13399 19.0396 8.35487C18.9883 8.38152 18.9386 8.41107 18.8907 8.44342L7.8024 15.0071L7.78902 15.0146C7.45012 15.2253 7.34623 15.6709 7.55697 16.0098C7.61906 16.1097 7.70459 16.1928 7.80613 16.2522L18.8945 22.8159C18.9425 22.8479 18.9922 22.8775 19.0433 22.9044C19.4715 23.1253 19.98 23.1253 20.4082 22.9044C20.4593 22.8775 20.509 22.848 20.557 22.8159L31.6454 16.2522C31.8669 16.123 32.0021 15.885 31.9996 15.6285Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09526 11.2471H16.3719V17.9172H9.09526V11.2471ZM30.5114 4.46682V1.41566C30.5289 0.652794 29.9251 0.0199889 29.1622 0.00170898H10.2793C9.51641 0.0199889 8.91258 0.652794 8.93006 1.41566V4.46682L20.0928 7.44356L30.5114 4.46682Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.92969 4.46533H16.3715V11.163H8.92969V4.46533Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8116 4.46533H16.3698V11.163L23.8116 17.8607H30.5093V11.163L23.8116 4.46533Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3698 11.158H23.8116V17.8556H16.3698V11.158Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3698 17.8611H23.8116V24.5588H16.3698V17.8611Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09634 17.9131H16.373V23.9767H9.09634V17.9131Z",
    fill: "#14447D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8151 17.8611H30.5128V24.5588H23.8151V17.8611Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.66 16.2094L31.6459 16.2169L20.5575 22.4531C20.5091 22.4829 20.46 22.5112 20.4087 22.5365C20.2203 22.6262 20.0158 22.6768 19.8074 22.6853L19.2016 22.3311C19.1504 22.3054 19.1007 22.2768 19.0527 22.2455L7.81555 15.8321H7.81034L7.44272 15.6267V28.2511C7.44845 29.0933 8.13569 29.7716 8.97797 29.7662H30.4894C30.502 29.7662 30.5132 29.7603 30.5266 29.7603C30.7045 29.7489 30.8799 29.7123 31.0475 29.6516C31.12 29.6209 31.1899 29.5846 31.2566 29.543C31.3065 29.5147 31.3921 29.453 31.3921 29.453C31.7733 29.1709 31.9989 28.7253 32.0008 28.2511V15.6267C32.0006 15.8682 31.8703 16.0908 31.66 16.2094Z",
    fill: "url(#paint0_linear_32101_39062)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.4049 15.5755V16.3494L19.8105 24.3323L7.80674 15.8359C7.80674 15.8318 7.8034 15.8285 7.7993 15.8285L6.69791 15.1662V14.608L7.15186 14.6006L8.11185 15.1513L8.13417 15.1587L8.21603 15.2108C8.21603 15.2108 19.4979 21.648 19.5277 21.6629L19.9593 21.9159C19.9965 21.901 20.0337 21.8862 20.0783 21.8713C20.1007 21.8564 31.2783 15.568 31.2783 15.568L31.4049 15.5755Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.66 16.2094L31.6458 16.2176L20.5575 22.4539C20.5091 22.4836 20.46 22.5119 20.4086 22.5372C19.978 22.7476 19.4744 22.7476 19.0438 22.5372C18.9928 22.5119 18.9431 22.4841 18.895 22.4539L7.80662 16.2176L7.79323 16.2094C7.57915 16.0933 7.44494 15.8702 7.44272 15.6267V28.2511C7.44805 29.0932 8.13505 29.7716 8.97716 29.7662C8.97716 29.7662 8.9772 29.7662 8.97723 29.7662H30.4663C31.3085 29.7716 31.9955 29.0933 32.0008 28.2511C32.0008 28.2511 32.0008 28.2511 32.0008 28.2511V15.6267C32.0006 15.8682 31.8703 16.0908 31.66 16.2094Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.7174 22.3611L20.5515 22.4541C20.5034 22.4847 20.4537 22.5128 20.4026 22.5382C20.2198 22.6279 20.021 22.6806 19.8177 22.693L24.0365 27.682L31.3958 29.4554C31.5974 29.3031 31.7578 29.1028 31.8624 28.8727L20.7174 22.3611Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M21.4691 21.9392L20.5515 22.4549C20.5034 22.4855 20.4537 22.5136 20.4026 22.539C20.2198 22.6288 20.021 22.6814 19.8177 22.6938L21.7943 28.1435L31.398 29.454C31.7763 29.1699 31.9991 28.7245 31.9993 28.2514V28.0884L21.4691 21.9392Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99806 29.7662H30.4641C30.7944 29.7679 31.1166 29.6636 31.3831 29.4686L19.2008 22.3326C19.1496 22.3069 19.0999 22.2783 19.052 22.247L7.8148 15.8336H7.80959L7.44272 15.6267V28.2079C7.44188 29.0677 8.13823 29.7654 8.99806 29.7662Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M17.8613 7.31892V23.1924C17.86 23.7489 17.5216 24.2492 17.0055 24.4575C16.8456 24.5262 16.6735 24.5617 16.4995 24.5617H7.44272V6.69901H8.9311V5.95483H16.4995C17.2513 5.95768 17.8597 6.5671 17.8613 7.31892Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.1171 8.05849V23.932C17.119 24.1117 17.0809 24.2897 17.0055 24.4529C16.7988 24.9623 16.305 25.2965 15.7553 25.299H7.44272V6.6944H15.7553C15.9712 6.69223 16.184 6.74609 16.3729 6.85069C16.8291 7.08051 17.117 7.54768 17.1171 8.05849Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.1171 8.05849V22.4436C17.1135 23.1951 16.5067 23.8041 15.7553 23.8107H7.44272V6.6944H15.7553C15.9712 6.69223 16.184 6.74609 16.3729 6.85069C16.8291 7.08051 17.117 7.54768 17.1171 8.05849Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.3729 8.05842V22.4435C16.3721 23.1962 15.7637 23.8069 15.0111 23.8106H7.44272V6.69434H15.0111C15.7636 6.69474 16.3733 7.30514 16.3729 8.05769C16.3729 8.05793 16.3729 8.05818 16.3729 8.05842Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.36409 6.69434H15.008C15.7614 6.69434 16.3721 7.30507 16.3721 8.05842V21.7023C16.3721 22.4557 15.7614 23.0664 15.008 23.0664H1.36409C0.610716 23.0664 0 22.4557 0 21.7023V8.05842C0 7.30507 0.610733 6.69434 1.36409 6.69434Z",
    fill: "url(#paint1_linear_32101_39062)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.26178 12.4186C4.59798 11.7023 5.14065 11.1029 5.82011 10.6973C6.57258 10.2665 7.42932 10.0517 8.29602 10.0767C9.09931 10.0592 9.89195 10.2629 10.5874 10.6653C11.2412 11.0552 11.7678 11.6265 12.1033 12.3099C12.4686 13.063 12.6507 13.8917 12.6346 14.7285C12.6523 15.6031 12.465 16.4696 12.0876 17.2588C11.7442 17.9666 11.2009 18.5583 10.5249 18.9607C9.80263 19.3755 8.98056 19.5845 8.14793 19.565C7.32749 19.5848 6.51737 19.3789 5.80598 18.9697C5.14647 18.5792 4.61326 18.0072 4.26998 17.322C3.90249 16.5799 3.71826 15.7605 3.73268 14.9324C3.71737 14.0653 3.89825 13.206 4.26178 12.4186ZM5.9228 16.4595C6.10205 16.9124 6.40603 17.3051 6.79945 17.5922C7.20017 17.8722 7.68001 18.0167 8.16875 18.0045C8.68923 18.025 9.20227 17.8756 9.63033 17.5788C10.0188 17.2926 10.3148 16.8988 10.4817 16.4461C10.6683 15.9406 10.7603 15.405 10.7533 14.8662C10.7591 14.3222 10.6725 13.7812 10.4973 13.2662C10.3425 12.8012 10.0561 12.3912 9.67275 12.086C9.25542 11.7751 8.74376 11.6174 8.22381 11.6394C7.72449 11.6265 7.2339 11.7721 6.82252 12.0554C6.42244 12.3437 6.1127 12.7399 5.9295 13.1978C5.52309 14.2472 5.52098 15.4101 5.92354 16.461L5.9228 16.4595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8151 4.46533H30.5128V11.163H23.8151V4.46533Z",
    fill: "#50D9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32101_39062",
    x1: 19.7218,
    y1: 15.6267,
    x2: 19.7218,
    y2: 29.7663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32101_39062",
    x1: 2.84416,
    y1: 5.62846,
    x2: 13.5279,
    y2: 24.1323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1784D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#107AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A63C9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32101_39062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 29.7674,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOutlookCalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "outlook-calendar.8002d4ee7abe15718b64254eca2a9cd1.svg";